<template>
    <nav>
        <!--<button v-bind:click="showMenu(isVisible)">Menu</button>-->
        <!--<div v-for="article in myArticles" 
        :key="article.id">
        <router-link :to="{ name: 'Article', params: {slug: article.slug} }">{{ article.title }}</router-link> |
        </div>-->
    </nav>
</template>

<script>
import articlesJSON from '@/content.js';

export default {
  data(){
    return {
      myArticles: articlesJSON.articles,
      isVisible: false,
    }
  },
  methods: {
    showMenu(isVisible){
      isVisible = !isVisible;
      
      return isVisible;
    }
  }
};
</script>